/**
 * @format
 * @description Sponsored video page (with special meta keyword)
 */
export default {
  // available-slots-for-tier: {
  //   html: [],
  //   ldbd: [],
  //   flex: [],
  //   btyb: []
  // },
  mobile: {
    html: [[1, 1]],
    flex: [[300, 250]],
    btyb: [[160, 30]]
  },
  portrait: {
    html: [[1, 1]],
    ldbd: [[728, 90]],
    btyb: [[160, 30]]
  },
  landscape: {
    html: [[1, 1]],
    ldbd: [[728, 90]],
    btyb: [[160, 30]]
  },
  desktop: {
    html: [[1, 1]],
    ldbd: [[728, 90]],
    btyb: [[160, 30]]
  }
};
